<template>
    <el-form
            ref="exhibitionForm"
            :model="form"
            :rules="rules"
            label-width="120px"
            class="exhibition-form"
    >
        <el-tabs v-model="activeTab">
            <el-tab-pane label="基本信息" name="basic">
                <el-form-item label="展会名称" prop="title">
                    <el-input
                            v-model="form.title"
                            placeholder="请输入展会名称"
                            clearable
                            maxlength="100"
                            show-word-limit
                    />
                </el-form-item>

                <el-form-item label="展会封面" prop="cover">
                    <el-upload
                            class="avatar-uploader"
                            :action="uploadUrl"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload"
                            :headers="uploadHeaders"
                    >
                        <img v-if="form.cover" :src="form.cover" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <div class="upload-tips">建议尺寸：800x600px，大小不超过2MB</div>
                </el-form-item>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="展会时间" prop="time">
                            <el-date-picker
                                    v-model="form.time"
                                    type="datetimerange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    style="width: 100%"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="展会状态" prop="status">
                            <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%">
                                <el-option label="进行中" value="ongoing" />
                                <el-option label="即将开始" value="upcoming" />
                                <el-option label="已结束" value="ended" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="展会地点" prop="location">
                    <el-input
                            v-model="form.location"
                            placeholder="请输入展会地点"
                            clearable
                    />
                </el-form-item>

                <el-form-item label="主办方" prop="organizer">
                    <el-input
                            v-model="form.organizer"
                            placeholder="请输入主办方"
                            clearable
                    />
                </el-form-item>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="参展商数量" prop="exhibitors">
                            <el-input-number
                                    v-model="form.exhibitors"
                                    :min="0"
                                    :step="100"
                                    style="width: 100%"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="预计观众" prop="visitors">
                            <el-input-number
                                    v-model="form.visitors"
                                    :min="0"
                                    :step="1000"
                                    style="width: 100%"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="展览面积(m²)" prop="area">
                            <el-input
                                    v-model="form.area"
                                    placeholder="请输入展览面积"
                                    clearable
                            >
                                <template slot="append">m²</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="展品类别" prop="categories">
                            <el-input
                                    v-model="form.categories"
                                    placeholder="请输入展品类别数量"
                                    clearable
                            />
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="热门标签" prop="isHot">
                    <el-switch
                            v-model="form.isHot"
                            active-text="是"
                            inactive-text="否"
                    />
                </el-form-item>

                <el-form-item label="展会介绍" prop="introduction">
                    <el-input
                            v-model="form.introduction"
                            type="textarea"
                            :rows="4"
                            placeholder="请输入展会详细介绍"
                            maxlength="2000"
                            show-word-limit
                    />
                </el-form-item>
            </el-tab-pane>

            <el-tab-pane label="展品范围" name="scope">
                <el-form-item label="展品范围" prop="scopeList">
                    <el-input
                            v-model="tempScopeItem"
                            placeholder="请输入展品类别"
                            style="width: 300px; margin-right: 10px"
                            @keyup.enter.native="addScopeItem"
                    >
                        <el-button slot="append" icon="el-icon-plus" @click="addScopeItem"></el-button>
                    </el-input>

                    <el-tag
                            v-for="(item, index) in form.scopeList"
                            :key="index"
                            closable
                            @close="removeScopeItem(index)"
                            style="margin-right: 10px; margin-bottom: 5px"
                    >
                        {{ item }}
                    </el-tag>
                </el-form-item>
            </el-tab-pane>

            <el-tab-pane label="联系信息" name="contact">
                <el-form-item label="联系人" prop="contactPerson">
                    <el-input
                            v-model="form.contactPerson"
                            placeholder="请输入联系人姓名"
                            clearable
                    />
                </el-form-item>

                <el-form-item label="联系电话" prop="contactPhone">
                    <el-input
                            v-model="form.contactPhone"
                            placeholder="请输入联系电话"
                            clearable
                    />
                </el-form-item>

                <el-form-item label="联系邮箱" prop="contactEmail">
                    <el-input
                            v-model="form.contactEmail"
                            placeholder="请输入联系邮箱"
                            clearable
                    />
                </el-form-item>

                <el-form-item label="参展费用" prop="fees">
                    <el-input
                            v-model="form.fees"
                            type="textarea"
                            :rows="2"
                            placeholder="请输入参展费用说明"
                    />
                </el-form-item>

                <el-form-item label="展位规格" prop="boothSpec">
                    <el-input
                            v-model="form.boothSpec"
                            placeholder="请输入展位规格说明"
                            clearable
                    />
                </el-form-item>
            </el-tab-pane>

            <el-tab-pane label="观众服务" name="visitor">
                <el-form-item label="参观时间" prop="visitingHours">
                    <el-input
                            v-model="form.visitingHours"
                            placeholder="如：09:00-17:00"
                            clearable
                    />
                </el-form-item>

                <el-form-item label="门票信息" prop="ticketInfo">
                    <el-input
                            v-model="form.ticketInfo"
                            type="textarea"
                            :rows="2"
                            placeholder="请输入门票信息"
                    />
                </el-form-item>

                <el-form-item label="交通指南" prop="transportation">
                    <el-input
                            v-model="form.transportation"
                            type="textarea"
                            :rows="3"
                            placeholder="请输入交通指南"
                    />
                </el-form-item>
            </el-tab-pane>
        </el-tabs>
    </el-form>
</template>

<script>
    export default {
        name: 'ExhibitionForm',
        props: {
            formData: {
                type: Object,
                default: () => ({})
            },
            isEdit: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                activeTab: 'basic',
                form: {
                    id: undefined,
                    title: '',
                    cover: '',
                    time: [],
                    status: 'upcoming',
                    location: '',
                    organizer: '',
                    exhibitors: 0,
                    visitors: 0,
                    area: '',
                    categories: '',
                    isHot: false,
                    introduction: '',
                    scopeList: [],
                    contactPerson: '',
                    contactPhone: '',
                    contactEmail: '',
                    fees: '',
                    boothSpec: '',
                    visitingHours: '',
                    ticketInfo: '',
                    transportation: ''
                },
                tempScopeItem: '',
                rules: {
                    title: [
                        { required: true, message: '请输入展会名称', trigger: 'blur' },
                        { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
                    ],
                    cover: [
                        { required: true, message: '请上传展会封面', trigger: 'change' }
                    ],
                    time: [
                        { required: true, message: '请选择展会时间', trigger: 'change' }
                    ],
                    status: [
                        { required: true, message: '请选择展会状态', trigger: 'change' }
                    ],
                    location: [
                        { required: true, message: '请输入展会地点', trigger: 'blur' }
                    ]
                },
                uploadUrl: process.env.VUE_APP_UPLOAD_URL,
                uploadHeaders: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            }
        },

        watch: {
            formData: {
                immediate: true,
                deep: true,
                handler(val) {
                    if (val) {
                        this.form = {
                            ...this.form,
                            ...val,
                            time: val.startTime && val.endTime ? [val.startTime, val.endTime] : []
                        }
                    }
                }
            }
        },

        methods: {
            // 验证表单
            validate() {
                return new Promise((resolve) => {
                    this.$refs.exhibitionForm.validate((valid) => {
                        resolve(valid)
                    })
                })
            },

            // 重置表单
            resetForm() {
                this.$refs.exhibitionForm.resetFields()
                this.form = {
                    id: undefined,
                    title: '',
                    cover: '',
                    time: [],
                    status: 'upcoming',
                    location: '',
                    organizer: '',
                    exhibitors: 0,
                    visitors: 0,
                    area: '',
                    categories: '',
                    isHot: false,
                    introduction: '',
                    scopeList: [],
                    contactPerson: '',
                    contactPhone: '',
                    contactEmail: '',
                    fees: '',
                    boothSpec: '',
                    visitingHours: '',
                    ticketInfo: '',
                    transportation: ''
                }
                this.tempScopeItem = ''
                this.activeTab = 'basic'
            },

            // 获取表单数据
            getFormData() {
                const data = {
                    ...this.form,
                    startTime: this.form.time?.[0] || '',
                    endTime: this.form.time?.[1] || ''
                }

                // 删除临时字段
                delete data.time

                return data
            },

            // 添加快捷键
            addScopeItem() {
                if (this.tempScopeItem.trim()) {
                    if (!this.form.scopeList.includes(this.tempScopeItem.trim())) {
                        this.form.scopeList.push(this.tempScopeItem.trim())
                        this.tempScopeItem = ''
                    } else {
                        this.$message.warning('该展品类别已存在')
                    }
                }
            },

            // 移除展品类别
            removeScopeItem(index) {
                this.form.scopeList.splice(index, 1)
            },

            // 上传成功
            handleAvatarSuccess(res) {
                if (res.code === 200) {
                    this.form.cover = res.data.url
                    this.$message.success('上传成功')
                } else {
                    this.$message.error(res.message || '上传失败')
                }
            },

            // 上传前校验
            beforeAvatarUpload(file) {
                const isImage = /^image\/(jpeg|png|jpg|gif|webp)$/.test(file.type)
                const isLt2M = file.size / 1024 / 1024 < 2

                if (!isImage) {
                    this.$message.error('只能上传图片格式文件!')
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!')
                }

                return isImage && isLt2M
            }
        }
    }
</script>

<style lang="scss" scoped>
    .exhibition-form {
        padding: 20px 10px;

        .avatar-uploader {
            ::v-deep .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
                width: 178px;
                height: 178px;

                &:hover {
                    border-color: #409EFF;
                }
            }

            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 178px;
                height: 178px;
                line-height: 178px;
                text-align: center;
            }

            .avatar {
                width: 178px;
                height: 178px;
                display: block;
            }
        }

        .upload-tips {
            font-size: 12px;
            color: #909399;
            margin-top: 10px;
        }
    }
</style>
